import Cookie from 'js-cookie'

const FACEBOOK_CONVERSION_COOKIE_KEY = '_fbc'
const FACEBOOK_PIXEL_COOKIE_KEY = '_fbp'
export const PINTEREST_COOKIE_KEY = '_epik'
export const GCLID_COOKIE_KEY = '_gclid'

export function getDomainName() {
  if (typeof window === 'undefined' || !window?.location) return ''

  const hostname = window.location.hostname
  if (window.app.envName === 'test') return hostname

  const parts = hostname.split('.')
  const rootDomain = parts.length <= 2 ? hostname : parts.slice(-2).join('.')
  return `.${rootDomain}`
}

export const getSocialMediaClickIds = () =>
  [PINTEREST_COOKIE_KEY, FACEBOOK_CONVERSION_COOKIE_KEY, FACEBOOK_PIXEL_COOKIE_KEY, GCLID_COOKIE_KEY].reduce(
    (acc, key) => {
      const value = Cookie.get(key)
      if (value) acc[key] = value
      return acc
    },
    {},
  )
